/*
# -----------------------------------------------------------------------------
# Component: helpListMixin.js
# Author: antonio.ramirez@pst.sg
# Created Date: 30/Jul/2020
# Comments: Responsible for all common help list initialisation
# -----------------------------------------------------------------------------
*/

export const helpListMixin = {
  data() {
    return {
      totalItems: 0,
      selected: [],
      selectedItems: [],
      checkedItemsAll: [],
      checkedItems: [],
      selectedAll: false
    }
  },
  methods: {
    collectItems(event, item) {
      if (event) {
        if (this.checkedItems.toString() === 'All') {
          this.doReset()
        }
        this.checkedItems.push(item)
        this.checkedItems.sort()
      } else {
        // AR: Remove item from array
        this.checkedItems.splice(this.checkedItems.indexOf(item), 1)
        this.checkedItems.sort()
      }
    },
    toggleAll() {
      this.doReset()
    },
    toggleSelected() {
      this.selected = this.selectedItems.slice()
    },
    doReset() {
      this.checkedItems = []
      this.selected = []
      this.checkedItemsAll = []
    },
    doSelect(opt, caller) {
      let selectedObj = {}
      if (opt === 'All') {
        this.doReset()
        this.checkedItemsAll.push('All')
        selectedObj = {
          finalSelectedItems: this.checkedItemsAll
        }
      } else {
        if (this.checkedItems.length === 0) {
          selectedObj = {
            finalSelectedItems: ['All']
          }
        } else {
          selectedObj = {
            finalSelectedItems: this.checkedItems
          }
        }
      }
      this.$emit('doAssign', selectedObj)
      this.$emit('close', caller)
    },
    doSelectExclude(opt, caller) {
      let selectedObj = {}
      if (opt === 'None') {
        this.doReset()
        selectedObj = {
          finalSelectedItems: ['']
        }
      } else {
        if (this.checkedItems.length === 0) {
          selectedObj = {
            finalSelectedItems: ['']
          }
        } else {
          selectedObj = {
            finalSelectedItems: this.checkedItems
          }
        }
      }
      this.$emit('doAssign', selectedObj)
      this.$emit('close', caller)
    },
    // new version of select
    enterSelect() {
      if (!this.selectedAll) {
        let templist = []
        if (this.selected.length > 0) {
          this.selected.map(data => {
            templist.push(data.key)
          })
        }
        templist.sort()
        this.checkedItems = templist
      }
      this.selectedAll = false
    },
    enterSelectInsured() {
      if (!this.selectedAll && !this.onPagination) {
        let templist = []
        if (this.selected.length > 0) {
          this.selected.map(data => {
            templist.push(data.key)
          })
        }
        let allItemsKey = []
        for (let i = 0; i < this.allItems.length; i++) {
          allItemsKey.push(this.allItems[i].key)
        }
        allItemsKey = allItemsKey.filter(item => !templist.includes(item))
        templist.sort()
        for (let i = 0; i < templist.length; i++) {
          this.checkedItems.push(templist[i])
        }
        this.checkedItems = this.checkedItems.filter((value, index, self) => {
          return self.indexOf(value) === index
        })
        this.checkedItems = this.checkedItems.filter(item => !allItemsKey.includes(item))
      }
      this.checkedItems.sort()
      this.selectedAll = false
    },
    enterSelectAll(pagination, items, selected) {
      let pageSize = pagination.itemsPerPage
      if (selected.length === 0) {
        if (pageSize > items.length || this.checkedItems.length === items.length) {
          this.selectedAll = true
          this.checkedItems = []
        }
        if (pageSize < items.length) {
          for (let i = 0; i < pageSize; i++) {
            this.checkedItems.push(items[i].key)
          }
        }
      } else {
        this.checkedItems = []
      }
      // this.selectedAll = true
      // this.checkedItems = []
    }
  }
}
